import * as React from 'react';
import { getStringTable } from '../../utilities/localizationUtilities.dynamic';
export async function getPreviewLabelCalloutWithStrings(locale, identityType) {
    const [stringTable, PreviewLabelCalloutModule] = await Promise.all([
        getStringTable(locale),
        import(/* webpackChunkName: "previewLabelCallout" */ './PreviewLabelCallout')
    ]);
    return {
        default: (partialProps)=>/*#__PURE__*/ React.createElement(PreviewLabelCalloutModule.PreviewLabelCallout, {
                appColors: partialProps.appColors,
                title: identityType === 'Consumer' ? stringTable.previewLabelDialogTitleConsumer : stringTable.previewLabelDialogTitle,
                firstPara: identityType === 'Consumer' ? stringTable.previewLabelDialogFirstParaConsumer : stringTable.previewLabelDialogFirstPara,
                secondPara: identityType === 'Consumer' ? stringTable.previewLabelDialogSecondParaConsumer : undefined,
                gettingStartedText: identityType === 'Consumer' ? stringTable.previewLabelDialogGettingStartedLinkText : undefined,
                termsOfUseText: stringTable.previewLabelDialogTermsLinkText,
                privacyAndCookiesText: stringTable.previewLabelDialogPrivacyLinkText,
                thirdPartyNoticesText: stringTable.previewLabelDialogThirdPartyLinkText,
                buttonLabel: stringTable.previewLabelDialogConfirmButtonText,
                target: partialProps.target,
                onDismiss: partialProps.onDismiss,
                linksLocale: locale
            })
    };
}
